import { Fragment, useEffect, useState } from 'react';

const AIModelSelector = ({ selectName, onSelect, value = null, isImageModel = false, disabled = false }) => {
	const [ aiModel, setAiModel ] = useState();

	useEffect(
		() => {
			if (value) {
				setAiModel(value);
			} else {
				setAiModel('gpt-3.5-turbo');
			}
		},
		[ value ]
	);

	const handleModelSelect = (e) => {
		setAiModel(e.target.value);

		if (onSelect) {
			onSelect(e);
		}
	};

	return (
		<select
			className="form-select"
			name={selectName}
			value={aiModel}
			onChange={(e) => handleModelSelect(e)}
			required
			disabled={disabled}
		>
			{isImageModel ? (
				<Fragment>
					<option value="dall-e-2">DALL·E 2</option>
					<option value="gpt-image-1">GPT Image 1</option>
				</Fragment>
			) : (
				<Fragment>
					<option value="gpt-3.5-turbo">GPT-3.5 Turbo</option>
					<option value="gpt-4o-mini">GPT-4o mini</option>
					<option value="gpt-4.1-mini">GPT-4.1 mini</option>
				</Fragment>
			)}
		</select>
	);
};

export default AIModelSelector;
